import { Box, Loader, ModBox, Text, useWindowDimensions } from '@jfs/ui-new'
import { useFocusEffect, useNavigation } from '@react-navigation/native'
import React, { useEffect, useState } from 'react'
import ActionsMenu from '../../../../components/ActionMenu/ActionsMenu'
import { Filters } from '../../../../components/FiltersWeb'
import { filterTypes } from '../../../../components/FiltersWeb/types'
import { NewTable } from '../../../../components/NewTable'
import { useLazyApiData, useStores } from '../../../../data/store'
import { filtersData } from '../../../../utils'
import { aadharCheckerMakerTitles, getCustomColumnWidth } from '../../../../utils/constants'
import { styles } from '../Checker'

const Header = ({ fetchDataOnChange, filterVisible, setFilterVisible, filterApplied }: any) => {
  return (
    <Box {...styles.header}>
      <ModBox w={'100%'}>
        <Text title={'My Queue (Maker)'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
        <ActionsMenu
          fetchDataOnChange={fetchDataOnChange}
          filterVisible={filterVisible}
          setFilterVisible={setFilterVisible}
          showSearch={true}
          enableFilter
          showCalendar
          defaultPage={1}
          type="aadharRedactionMaker"
          filterApplied={filterApplied}
        />
      </ModBox>
    </Box>
  )
}
const AadharMakerQueue = () => {
  const {
    fetchAadharRedactionMakerList,
    getAadharRedactionMakerList,
    selectedFilteredData,
    updateFilters,
    makerListlength,
    setSideMenuRefresh,
    saveState,
    resetState,
    restoreFiltersToDefaults,
    setSearchFilterBy,
    resetFeePkgId,
    resetCheckerApplicationStatus,
    checkSelected,
    clearAadharRedactionsEditedNonEditedDocs,
  } = useStores((store) => ({
    fetchAadharRedactionMakerList: store.fetchAadharRedactionMakerList,
    getAadharRedactionMakerList: store.getAadharRedactionMakerList,
    selectedFilteredData: store.filter.getFilterData,
    updateFilters: store.filter.updateFilters,
    makerListlength: store.makerList.length,
    setSideMenuRefresh: store.setSideMenuRefresh,
    saveState: store.filter.saveState,
    resetState: store.filter.resetState,
    restoreFiltersToDefaults: store.filter.restoreFiltersToDefaults,
    applicationStatusLength: store.filter.applicationStatus.length,
    setSearchFilterBy: store.onboarding.setSearchFilterBy,
    resetFeePkgId: store.onboarding.resetFeePkgId,
    resetCheckerApplicationStatus: store.resetCheckerApplicationStatus,
    checkSelected: store.filter.checkSelected,
    listLength: store.aadharRedactionMakerList.length,
    clearAadharRedactionsEditedNonEditedDocs: store.clearAadharRedactionsEditedNonEditedDocs,
  }))
  const navigation = useNavigation()
  const [listData, setListData] = useState<any>([])
  const [isLoading, setLoading] = useState(false)
  const [filterVisible, setFilterVisible] = useState(false)

  const [lazyFetchMakerListList, { state }] = useLazyApiData(fetchAadharRedactionMakerList)

  useEffect(() => {
    if (state === 'fulfilled' || state === 'rejected') {
      const list = getAadharRedactionMakerList()
      setListData(list)
      setLoading(false)
      clearAadharRedactionsEditedNonEditedDocs()
    }
  }, [getAadharRedactionMakerList, state, makerListlength, clearAadharRedactionsEditedNonEditedDocs])

  useFocusEffect(
    React.useCallback(() => {
      setLoading(true)
      lazyFetchMakerListList()
      setSideMenuRefresh(true)
      setSearchFilterBy('Entity ID')
      updateFilters('applicationStatus', 'ALL')
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []),
  )

  const onPress = (item: any) => {
    setSearchFilterBy('Entity ID')
    resetFeePkgId()
    resetCheckerApplicationStatus()

    if (item?.applicationStatus === 'Error') {
      navigation.reset({
        index: 0,
        routes: [
          {
            name: 'aadharRedactionDetails',
            params: {
              itemData: item,
              from: 'AD_MAKER_QUEUE',
              isApprovedByChecker: true,
              showApproveReject: false,
              type: 'AD_MAKER_QUEUE',
            },
          },
        ],
      })
    } else {
      navigation.reset({
        index: 0,
        routes: [
          {
            name: 'aadharRedactionDetails',
            params: {
              itemData: item,
              from: 'AD_MAKER_QUEUE',
              isApprovedByChecker: false,
              showApproveReject: false,
              type: 'AD_MAKER_QUEUE',
            },
          },
        ],
      })
    }
    // setSideMenuRefresh(true)
  }

  const { width } = useWindowDimensions()

  const fetchDataOnChange = () => {
    console.count('===> fetchDataOnChange')
    setLoading(true)
    lazyFetchMakerListList()
  }

  const onFilterPress = () => {
    setFilterVisible(false)
    resetState()
  }

  const applyFilter = () => {
    fetchDataOnChange()
    setFilterVisible(false)
  }

  const handleFilterVisibility = (visible: boolean) => {
    setFilterVisible(visible)
    if (visible) {
      saveState()
    }
  }

  const restoreFilterDefaults = () => {
    restoreFiltersToDefaults()
  }

  if (isLoading) {
    return <Loader />
  }
  return (
    <Box {...styles.container}>
      <Header
        fetchDataOnChange={fetchDataOnChange}
        filterVisible={filterVisible}
        setFilterVisible={handleFilterVisibility}
        filterApplied={
          selectedFilteredData?.applicationStatus?.length > 0 &&
          (selectedFilteredData?.applicationStatus?.includes('Completed') ||
            selectedFilteredData?.applicationStatus?.includes('Rejected') ||
            selectedFilteredData?.applicationStatus?.includes('Error') ||
            selectedFilteredData?.applicationStatus?.includes('Pending For Approval'))
        }
      />
      <ModBox padding={16} show={!filterVisible}>
        <NewTable
          data={listData}
          rowHeight={48}
          headerHeight={64}
          height={544}
          customWidthFunc={getCustomColumnWidth}
          tableWidth={width > 1200 ? width - 290 : width}
          headerRowKeys={aadharCheckerMakerTitles}
          onRowClick={onPress}
        />
      </ModBox>
      <ModBox show={filterVisible}>
        <Filters
          onPress={onFilterPress}
          selectedFilteredData={selectedFilteredData}
          updateFilters={updateFilters}
          filterData={[filtersData]}
          checkSelected={checkSelected}
          apply={applyFilter}
          selectedValue={selectedFilteredData?.applicationStatus}
          mode={filterTypes.applicationStatus}
          restoreDefaults={restoreFilterDefaults}
        />
      </ModBox>
    </Box>
  )
}

export default AadharMakerQueue
